<template>
  <div v-if="true">
      <InsightReportControl></InsightReportControl>
  </div>
</template>

<script>

import InsightReportControl from '../components/InsightReportControl'
import { mapState } from 'vuex'

export default {
  name: 'insights',
  components: {
    InsightReportControl
  },
  data: () => {
    return {}
  },
  computed: mapState({
    showDevelopment: function (state) {
      return state.auth.isDevelopment
    }
  })
}
</script>
